var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAt = function SvgAt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M640 480H0V0h640z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0000",
    d: "M640 480H0V319.997h640zm0-319.875H0V.122h640z"
  }))));
};
export default __webpack_public_path__ + "assets/78e4fe8bc34593071b5552ad36e59907.svg";
export { SvgAt as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/at.svg